<template>
  <fieldset>
    <legend class="sr-only">Calendar Option</legend>
    <span class="text-sm leading-5 font-medium text-gray-700">{{ label }}</span>
    <div class="mt-1 bg-white rounded-md -space-y-px">
      <div v-for="(option, index) of options" :key="option.label">
        <div :class="option.label == selectedOption ? 'bg-indigo-50 border-indigo-200 z-10' : 'border-gray-200'">
          <div
            class="relative border border-gray-200 p-4 flex"
            :class="
              index == options.length - 1
                ? 'rounded-bl-md rounded-br-md'
                : index == 0
                  ? 'rounded-tl-md rounded-tr-md'
                  : ''
            "
          >
            <div class="flex items-center h-5">
              <input
                :id="option.label"
                :name="option.label"
                :value="option.label"
                :checked="option.label === selectedOption"
                type="radio"
                class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out cursor-pointer"
                @change="updateSelection(option.label)"
              />
            </div>
            <label :for="option.label" class="ml-3 flex flex-col cursor-pointer">
              <span
                class="block text-sm leading-5 font-medium"
                :class="option.label == selectedOption ? 'text-indigo-900' : 'text-gray-900'"
              >
                {{ option.label }}
              </span>
              <span
                class="block text-sm leading-5"
                :class="option.label == selectedOption ? 'text-indigo-700' : 'text-gray-500'"
              >
                {{ option.description }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script setup>
import { ref, watchEffect } from 'vue';

const props = defineProps({
  label: String,
  options: Array,
  modelValue: String,
});

const selectedOption = ref(props.modelValue || (props.options.length > 0 ? props.options[0].label : ''));

watchEffect(() => {
  selectedOption.value = props.modelValue || (props.options.length > 0 ? props.options[0].label : '');
});

const emit = defineEmits(['input', 'update:modelValue']);

function updateSelection(value) {
  selectedOption.value = value;
  emit('update:modelValue', value);
}
</script>
